import { Component, inject, Input } from '@angular/core';
import { TpaSearchCoverageResExtended } from '../../../../models/http/tpa-http.model';
import { TpaDetailViewService } from './services/tpa-detail-view.service';
import { GenericCardComponent } from '../../../../../../shared/components/generic-card/generic-card.component';
import { CardAction } from '../../../../../../shared/components/generic-card/models/card-config.interface';
import { TpaService } from '../../../../services/tpa.service';
import { ActionId } from '../../../../models/sob.enum';

@Component({
  selector: 'app-tpa-detail-view',
  standalone: true,
  imports: [GenericCardComponent],
  templateUrl: './tpa-detail-view.component.html',
  styleUrl: './tpa-detail-view.component.scss',
})
export class TpaDetailViewComponent {
  private _detailViewData: TpaSearchCoverageResExtended[] | null = null;

  private tpaDetailViewService = inject(TpaDetailViewService);
  private tpaService = inject(TpaService);

  @Input()
  set detailViewData(value: TpaSearchCoverageResExtended[] | null) {
    this._detailViewData = this.tpaDetailViewService.setCardConfig(value);
  }

  get detailViewData(): TpaSearchCoverageResExtended[] | null {
    return this._detailViewData;
  }

  openDialog(cardAction: CardAction) {
    const actionId = cardAction.id;

    switch (actionId) {
      case ActionId.openSobDialog:
        this.tpaService.setSobOpenDialog(
          cardAction?.extraData?.planId,
          cardAction?.extraData?.showPdf,
        );
        break;
      case ActionId.openPolicyDialog:
        this.tpaService.setPolicyOpenDialog(cardAction?.extraData?.policyId);
        break;
    }
  }
}
